// EmployeeESIStatement

import { useState } from "react";
import { Reactable } from "../../components/ui/reactable";
import { ReportPageShell } from "../../components/ui/reportPageShell";
import { EMPLOYEE_ESI_REPORTS } from "../../constants/api";
import { EmployeeDetails } from "../../components/ui/cards";

const EmployeeESIStatement = () => {

    const [employeeESIStatementData, setEmployeeESIStatementData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
        const EmployeeESIStatementColumns = [
        {
            accessor: "employee_name",
            Header: "Employee",
            sortable: true,
            fixed: true,
            filterable: true,
            maxWidth: "300px",
            Cell: ({ value, row }) => {
                const record = row;

                let empDetails = {
                    ...record?.employee,
                    designation_id: record?.employee?.designation
                        ? {
                            id: record?.employee.designation.id,
                            designation_name: record?.employee.designation.name,
                        }
                        : { id: 0, designation_name: "" },
                    first_name: record?.employee?.employee_name || "-",
                    id: record?.employee?.employee_id || "-",
                };

                return <EmployeeDetails details={empDetails} size="xs" />;
            },
        },
        {
            accessor: "ESI_no",
            Header: "ESI No",
            filterable: true,
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "salary_days",
            Header: "Salary Days",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "ESI_Wages",
            Header: "ESI Wages",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "ESI_Contirbutions",
            Header: "ESI Contributions",
            Cell: ({ value }) => value ?? "-",
        }
    ];

    return (
        <ReportPageShell title="Employee ESI Statements Report " count={totalRecords}>

            <Reactable
                columns={EmployeeESIStatementColumns}
                data={employeeESIStatementData}
                setData={setEmployeeESIStatementData}
                setTotalCount={setTotalRecords}
                url={EMPLOYEE_ESI_REPORTS}
                serverSide={true}
                rowSize="sm"
                isCSVRequired={true}
                isPDFRequired={true}
                isMonthYearRequired={true}
            />
        </ReportPageShell>
    );
}

export default EmployeeESIStatement;